import Cookie from 'js-cookie';
export const NUMBERFORMAT = new Intl.NumberFormat('en-US');
export const TOKEN = 'token';

export const getCookie = () => Cookie.get('token');

export const DASHBOARD = `https://service-leasera-dashboard-${process.env.REACT_APP_DEVELOP}-uc.a.run.app/leasera_dashboard/graphql`;
export const PERSON_URL = `https://service-person-ywkd3aaksq-uc.a.run.app/person/graphql`;
export const GIFT_EXCHANGE_URL = `https://service-gift-exchange-ywkd3aaksq-uc.a.run.app/gift_exchange/graphql`;
